<template>
  <v-layout column fill-height class="selection-container">
    <v-flex>
      <Card class="fill-height">
        <Toolbar height="50px" class="sub-header">
          <v-toolbar-title class="body-2">{{ $t('Equipments') }}</v-toolbar-title>
        </Toolbar>
        <v-layout fill-height class="scroll-content">
          <v-flex xs12 fill-height class="fill-height overflow-scroll">
            <v-list class="primary" subheader>
              <v-list-tile v-for="item in fullDeviceList" :key="item.title" class="primaryText--text" avatar
                @click="active = item.value">
                <v-icon v-show="item.value === active" class="accent--text">
                  chevron_right
                </v-icon>
                <v-list-tile-content>
                  <v-badge>
                    <span
                      :class="{'accent--text font-weight-bold': item.value === active, 'primaryText--text':  item.value !== active}">{{item.text}}</span>
                  </v-badge>
                </v-list-tile-content>
                <v-list-tile-action>
                  <span>
                    <router-link v-if="deviceLink[item.value]" :to="deviceLink[item.value]">
                      <v-icon color="primaryText">launch</v-icon>
                    </router-link>
                  </span>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </Card>
    </v-flex>
    <v-flex>
      <Card class="fill-height">
        <Toolbar height="50px" class="sub-header">
          <v-toolbar-title class="body-2">{{ $t('Stats') }}</v-toolbar-title>
        </Toolbar>
        <v-layout row wrap class="pa-2">
          <v-flex>
            <Progress :value="resolvedCount" :percentage="percentage(resolvedCount, resolvedCount)"
              :width="progressWidth" :size="progressSize" :label="$t('Resoved')" color="success"></Progress>
          </v-flex>
          <v-flex>
            <Progress :value="activeCount" :percentage="percentage(activeCount, activeCount)" :width="progressWidth"
              :size="progressSize" color="error" :label="$t('New')"></Progress>
          </v-flex>
          <v-flex>
            <Progress :value="ackCount" :percentage="percentage(ackCount, ackCount)" :width="progressWidth"
              :size="progressSize" :label="$t('Acknowledge')" color="warning"></Progress>
          </v-flex>
        </v-layout>
      </Card>
    </v-flex>
  </v-layout>
</template>

<script>
import Progress from '@/components/Alert-v2/Progress'

import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  EventBus
} from '@/services/event-bus'

export default {
  components: {
    Progress
  },
  data() {
    return {
      deviceLink: {
        inverter: '/inverter',
        scb: '/scb',
        transformer: '/other-sensor',
        breaker: '/other-sensor',
        compute: '/calculated-analytics'
      }
    }
  },
  computed: {
    ...mapGetters(['getActivePlantInfo', 'getSelectedPlantId']),
    ...mapGetters('alert', ['device', 'activeCount',
      'ackCount',
      'resolvedCount',
      'getTotalAlert'
    ]),
    fullDeviceList() {
      const clonedList = _.cloneDeep(this.getActivePlantInfo(['rule', 'comp_config', 'alert', 'options', 'deviceList'])).map(el => {
        el.text = this.$t(el.text)
        return el
      })
      return [{
        text: this.$t('Select All'),
        value: 'all'
      }, ...clonedList]
    },
    progressSize() {
      return this.$vuetify.breakpoint.smAndUp ? 80 : 60
    },
    progressWidth() {
      return this.$vuetify.breakpoint.smAndUp ? 10 : 5
    },
    active: {
      get() {
        return this.device
      },
      set(value) {
        this.setDevice(value)
      }
    }
  },
  methods: {
    ...mapActions('alert', ['setDevice']),
    percentage(actual, total) {
      return total ? parseFloat(((actual / total) * 100).toFixed(2)) : 0
    }
  },
  watch: {
    device() {
      EventBus.$emit('alertPageNum', 1)
    }
  }
}
</script>

<style>
.flex-column {
  flex-direction: column;
}

.selection-container {
  max-height: 748px;
  overflow: auto;
}

.consume-half {
  max-height: 50%;
  min-height: 50%;
}

.overflow-scroll {
  overflow: auto;
}

.bg-black {
  background-color: black;
}

.scroll-content {
  height: calc(100% - 46px);
  overflow: auto;
}
</style>
